export const toggleDisabled = id => {
    let btn = document.getElementById(id)
    btn.disabled = !btn.disabled
}